var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHat = function SvgHat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 2,
    d: "M17.25 17.25C16.8 12 14.175 7.125 10.125 3.75L8.25 2.25l.225 1.125c.825 3.675.6 7.5-.75 11.025l-.975 2.85a13.43 13.43 0 0 0 10.5 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 2,
    d: "M16.875 14.775C19.8 15.45 21.75 16.65 21.75 18c0 2.1-4.35 3.75-9.75 3.75S2.25 20.1 2.25 18c0-1.5 2.25-2.775 5.475-3.375"
  })));
};
export default SvgHat;